export default function BusinessIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_11671_2731'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width={size}
        height={size}
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_11671_2731)'>
        <path
          d='M2.36523 20.5769V3.0769H11.865V7.0769H21.6342V20.5769H2.36523ZM3.86498 19.0769H10.3652V16.5769H3.86498V19.0769ZM3.86498 15.0769H10.3652V12.5769H3.86498V15.0769ZM3.86498 11.0769H10.3652V8.5769H3.86498V11.0769ZM3.86498 7.0769H10.3652V4.5769H3.86498V7.0769ZM11.865 19.0769H20.1345V8.5769H11.865V19.0769ZM14.0575 12.5769V11.0769H17.7497V12.5769H14.0575ZM14.0575 16.5769V15.0769H17.7497V16.5769H14.0575Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
